import * as Yup    from 'yup';
import moment      from 'moment';
import { MAX_INT } from '@utils/constants';

export const auctionSchema = Yup.object().shape({
  vin                  : Yup.string().min(1).max(20).required(),
  vehicleBodyStyle     : Yup.string().required(),
  carBrandName         : Yup.string().required(),
  carModelName         : Yup.string().required(),
  miles                : Yup.number().min(1).max(MAX_INT).required(),
  featuresAndEquipment : Yup.string().required(),
  fullDisclosure       : Yup.string().required(),
  exteriorCondition    : Yup.string().required(),
  interiorCondition    : Yup.string().required(),
  mechanicalCondition  : Yup.string().required(),
  vehicleDescription   : Yup.string(),
  year                 : Yup.number().required()
    .test(
      'Year of creation',
      'Year must be greater or equal than 1900 and less on equal than present year',
      (value): boolean => value >= 1900 && value <= moment().year(),
    ),
});
